import { useEffect, useRef } from 'react';

// `onShown()` once, the first time at least half of `ref`'s element is on
// screen while `available` (the Ask box's "seen" count, #3262, and the
// "Where do I stand" card's, #3885). A browser with no IntersectionObserver
// counts it at once. StrictMode's double mount and re-renders count once.
export default function useShownOnce(ref, available, onShown) {
    const seen = useRef(false);
    const shownRef = useRef(onShown);
    shownRef.current = onShown;
    useEffect(() => {
        if (!available || seen.current) return undefined;
        const el = ref.current;
        const fire = () => {
            if (seen.current) return;
            seen.current = true;
            shownRef.current?.();
        };
        if (!el || typeof IntersectionObserver === 'undefined') { fire(); return undefined; }
        const io = new IntersectionObserver((entries) => {
            if (entries.some((e) => e.isIntersecting)) { fire(); io.disconnect(); }
        }, { threshold: 0.5 });
        io.observe(el);
        return () => io.disconnect();
    }, [available]);   // eslint-disable-line react-hooks/exhaustive-deps
}
